var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.currentVariation && _vm.currentVariation.stock.net < 11
      ? _c(
          "div",
          { key: "transition--stock", staticClass: "single-item__stock-outer" },
          [
            _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
              _c(
                "div",
                {
                  key: "transition--stock-" + _vm.currentVariation.stock.net,
                  staticClass:
                    "d-flex justify-content-center justify-content-lg-start"
                },
                [
                  _c("div", { staticClass: "single-item__stock-wrapper" }, [
                    _vm.currentVariation.stock.net === 0
                      ? _c("span", [
                          _vm._v(
                            "\n                        Der Artikel ist aktuell nicht auf Lager\n                    "
                          )
                        ])
                      : _c("span", [
                          _vm._v(
                            "\n                        Nur noch " +
                              _vm._s(_vm.currentVariation.stock.net) +
                              " Artikel auf Lager\n                    "
                          )
                        ])
                  ])
                ]
              )
            ])
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }